import Svg, { Path } from 'react-native-svg'

export const CaretIcon = ({ width = 22, height = 9, color = '#fff' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path fill={color} d="M11 9 .608 0h20.784L11 9Z" />
    </Svg>
  )
}
